/**************************************************
 * Nombre:       Formulario_Cuentas_Rango
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, MoveUpOutlined} from "@mui/icons-material";
import IngresoImagenCrop from "../../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoSelect from "../../../Modulo_formularios/Componentes/IngresoSelect";
import {RANGOSCUENTA} from "../../../Constantes";

const Formulario_Cuentas_Rango = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  editable={false}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'imgPortada'} {...props} ancho={4} alto={5}/>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoSelect Icono={MoveUpOutlined} nombre={'Rango'} dato={'rango'} {...props}
                                   opciones={RANGOSCUENTA}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={4} nombre={'Frase del rango'} dato={'descripcionRango'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Cuentas_Rango

